import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const ONLY_DIGITS_RE = /^[0-9]+$/;

/**
 * Video Playback Time rules:
 * - Digits only (no decimals, no negative, no alphabets/special)
 * - Must be >= 1
 * - Max value: 9999 (prompt: max digits 4)
 */
export const videoPlaybackTimeValidator = (min = 1, max = 9999): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || raw === '') return null; // required handled elsewhere

    const str = String(raw);

    if (!ONLY_DIGITS_RE.test(str)) {
      return { pattern: true };
    }

    const num = Number(str);
    if (!Number.isFinite(num)) return { pattern: true };

    if (num < min) return { min: { requiredMin: min, actual: num } };

    if (num > max) return { max: { requiredMax: max, actual: num } };

    return null;
  };
};

/**
 * Video Playback Limit rules:
 * - Digits only (no decimals, no negative, no alphabets/special)
 * - Must be >= 1
 * - Max value: 100 (prompt)
 */
export const videoPlaybackLimitValidator = (min = 1, max = 100): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || raw === '') return null; // required handled elsewhere

    const str = String(raw);

    if (!ONLY_DIGITS_RE.test(str)) {
      return { pattern: true };
    }

    const num = Number(str);
    if (!Number.isFinite(num)) return { pattern: true };

    if (num < min) return { min: { requiredMin: min, actual: num } };

    if (num > max) return { max: { requiredMax: max, actual: num } };

    return null;
  };
};

